import React, { useEffect, useState } from 'react'
import { Modal, Tooltip } from 'antd'
import { Button, ColumnProps, notification, Table, Widget } from '@digital/ui'
import { Divider } from 'antd';
import { Visibility } from '@app/components'
import { useRecoilValue } from 'recoil'
import { ordemCompraIdState } from '../atoms'
import { downloadArquivo, exclusaoLogicaDocumento, getDocumentosOrdemCompraId, ISasDocumentoOrdemCompra, substituirAnexoDocumentoOrdemCompra, substituirSasArquivoDocumentoOrdemCompra, viewArquivo } from '@app/api/sas/sasDocumentoOrdemCompra'
import UploadModalSubstituirAnexo from '@app/components/Upload/uploadModalSubstituirAnexo'
import { isObjNotEmpty } from '@app/helpers/objHelper'
import { GetFileExtension, imageFormats } from '@app/helpers'
import { isValidGuid } from '@app/helpers/geradorGuid';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';

interface Props {
    propostaId?: string
    fornecedorNome?: string
    sasTipoDocumentoId?: string
    hideExcluido?: boolean
    disabled?: boolean
}

const ModalExibicaoArquivos = (props: Props) => {
    const { propostaId, fornecedorNome, sasTipoDocumentoId, hideExcluido = false, disabled = false } = props
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [exibirModal, setExibirModal] = useState(false)
    const [arquivos, setArquivos] = useState<ISasDocumentoOrdemCompra[]>([])
    const [update, setUpdate] = useState(false)

    useEffect(() => {
        setArquivos([]);
        if (exibirModal && propostaId) {
            getDocumentosOrdemCompraId({
                ordemCompraId,
                sasPropostaId: propostaId,
                sasTipoDocumentoId: sasTipoDocumentoId
            }).then(data => {
                if (data)
                    setArquivos(data)
            })
        }
    }, [exibirModal, propostaId, update])

    const columns = () => {
        let columns: ColumnProps<any>[] = []

        columns.push({
            title: 'Arquivo',
            dataIndex: 'descricao',
            // width: '40%'
        })

        columns.push({
            title: "Emitente",
            dataIndex: 'responsavel'
        })

        columns.push({
            title: "Status",
            dataIndex: 'vigencia'
        })

        columns.push({
            title: "Versão",
            dataIndex: 'versao'
        })

        columns.push({
            title: "Ações",
            width: '5%',
            render(text, record, index) {
                return <>
                    <Visibility visible={
                        record.enabled === true &&
                        record.pai === false &&
                        record.vigencia === "Vigente" &&
                        disabled === false &&
                        (
                            !isValidGuid(record.tipoDocumentoOrdemCompraId) ||
                            [EGuidTipoSasDocumento.AceiteRecebimentoPropostaTecnicasProponentes].includes(record.tipoDocumentoOrdemCompraId)
                        )
                    } >
                        <UploadModalSubstituirAnexo
                            hasJustificativa
                            label=''
                            hasData={false}
                            hasFile={false}
                            onSubmit={async (values) => {
                                return substituirSasArquivoDocumentoOrdemCompra({
                                    description: values.justificativa,
                                    file: values.arquivo,
                                    sasArquivoDocumentoOrdemCompraId: record.arquivoId,
                                }).then((data: any) => {
                                    if (data && data.valid) {
                                        setUpdate(!update)
                                        return true;
                                    }
                                    return false;
                                });
                            }}

                        />
                    </Visibility>
                    <Visibility
                        visible={isObjNotEmpty(record.arquivoId) && record.pai !== true}
                    >
                        <Tooltip title="Download Arquivo">
                            <Button
                                icon="ui-download"
                                type="link"
                                onClick={() => {
                                    downloadArquivo(
                                        record.arquivoId,
                                        record.arquivoNome
                                    );
                                }}
                            />
                        </Tooltip>
                    </Visibility>
                    <Visibility
                        visible={
                            GetFileExtension(record.arquivoNome) === 'pdf' ||
                            imageFormats.includes(
                                GetFileExtension(record.arquivoNome))
                        }
                    >
                        <Tooltip title="Visualizar Arquivo">
                            <Button
                                icon="files-view_file"
                                type="link"
                                onClick={() => {
                                    viewArquivo(
                                        record.arquivoId,
                                        record.arquivoNome
                                    );
                                }}
                            />
                        </Tooltip>
                    </Visibility>
                    <Visibility visible={record.enabled === true &&
                        (record.pai === true || record.multiple) &&
                        (!isValidGuid(record.tipoDocumentoOrdemCompraId)) &&
                        disabled === false
                    } >
                        <Tooltip title="Excluir Arquivo">
                            <Button
                                icon="commons-trash"
                                type="link"
                                onClick={() => {

                                    Modal.confirm({
                                        centered: true,
                                        okText: 'Excluir',
                                        cancelText: 'Cancelar',
                                        title: 'Deseja realmente excluir o arquivo atual?',
                                        onOk: () => {
                                            exclusaoLogicaDocumento(record.id).then(data => {
                                                if (data.valid) {
                                                    notification.success('Item removido com sucesso.');
                                                }
                                                setUpdate(!update)
                                            })
                                        },
                                    });
                                }}
                            />
                        </Tooltip>
                    </Visibility>
                </>
            },
        })

        return columns
    }

    return (
        <>
            <Tooltip title="Visualizar Arquivos" >
                <Button
                    onClick={() => setExibirModal(true)}
                    icon="messaging-attach"
                />
            </Tooltip>
            <Visibility visible={exibirModal} >
                <Modal
                    title={fornecedorNome ? "Documentos - " + fornecedorNome : "Documentos"}
                    width="680px"
                    visible={exibirModal}
                    onCancel={() => setExibirModal(false)}
                    footer={null}
                >
                    <Divider style={
                        { paddingTop: '8px' }
                    }
                        orientation='left' >Vigentes</Divider>
                    <Table
                        dataSource={arquivos.ativos}
                        columns={columns()}
                        rowKey={(record) =>
                            record.pai
                                ? `parent-${record.key}`
                                : `child-${record.arquivoId}`
                        }
                        pagination={false}
                    />

                    <Visibility visible={hideExcluido != true} >
                        <Divider style={{ paddingTop: '32px' }} orientation='left'>Excluídos</Divider>
                        <Table
                            dataSource={arquivos.excluidos}
                            columns={columns()}
                            rowKey="arquivoId"
                            pagination={false}
                        />
                    </Visibility>
                </Modal>
            </Visibility>
        </>
    )
}

export default ModalExibicaoArquivos
